/**
 * AlgorandHealthMetrics Component
 *
 * Health metrics panel for Algorand network.
 */

import { Icons } from '../Icons';
import { GenericHealthMetrics, networkConfigs } from '../common/GenericHealthMetrics';
import type { AlgorandNetworkMetrics } from '../../services/blockchainHealthApi';

const ALGO_COLOR = '#6366f1';

function renderAlgorandMetrics(metrics: Record<string, any>) {
  const m = (metrics || {}) as AlgorandNetworkMetrics;
  return (
    <>
      {/* Last Round */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Hash size={24} style={{ color: ALGO_COLOR, marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: ALGO_COLOR }}>
          {m.lastRound ?? '0'}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Block Height
        </div>
      </div>

      {/* Total Accounts */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Users size={24} style={{ color: '#8b5cf6', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#8b5cf6' }}>
          {m.totalAccounts ?? '0'}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Accounts
        </div>
      </div>

      {/* Total Assets */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Coins size={24} style={{ color: '#10b981', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#10b981' }}>
          {m.totalAssets ?? '0'}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          ASAs Created
        </div>
      </div>

      {/* TPS */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Zap size={24} style={{ color: '#f59e0b', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#f59e0b' }}>
          {(m.tps ?? 0).toLocaleString()}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Max TPS
        </div>
      </div>

      {/* Block Time */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Clock size={24} style={{ color: '#06b6d4', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#06b6d4' }}>
          {m.blockTime ?? 0}s
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Block Time
        </div>
      </div>
    </>
  );
}

export function AlgorandHealthMetrics() {
  const config = {
    ...networkConfigs.algorand,
    renderNetworkMetrics: renderAlgorandMetrics,
  };

  return <GenericHealthMetrics config={config} />;
}
